















import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import ChartHeader from './ChartHeader.vue'

@Component({
  name: 'LineArea',
  components: { Chart, ChartHeader }
})
export default class extends Vue {
  @Prop({ default: '#FFA100' }) private color!: string;
  @Prop({
    default: () => ['rgba(255, 161, 0, 0.59)', 'rgba(255, 161, 0, 0.15)']
  })
  private areaColor!: any[];
  @Prop({}) private dataList!: any;
  private chartId: string = '';
  private legend: any[] = [
    { name: '参考标准', color: '#aeaeae' },
    { name: '学员各分值区间占比', color: this.color }
  ];
  private option: any = {
    tooltip: {
      show: true,
      formatter: '{c}'
    },
    grid: {
      top: 20,
      right: 10,
      left: 30,
      bottom: 120
    },
    xAxis: {
      type: 'category',
      // boundaryGap: false,
      splitLine: {
        show: true,
        lineStyle: {
          color: '#eaeaea'
        }
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#999'
      },
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          color: '#eaeaea'
        }
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#999999'
      }
    },
    color: [
      // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
      {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          {
            offset: 0,
            color: this.areaColor[0] // 0% 处的颜色
          },
          {
            offset: 1,
            color: this.areaColor[1] // 100% 处的颜色
          }
        ],
        global: false // 缺省为 false
      }
    ],
    series: [
      {
        data: [820, 932, 901, 934, 1290, 1330, 1320],
        type: 'line',
        smooth: true,
        symbolSize: 6,
        lineStyle: {
          color: this.color
        },
        areaStyle: {}
      },
      {
        data: [766, 550, 550, 1234, 1400, 1330, 800],
        type: 'line',
        smooth: true,
        symbolSize: 0,
        color: '#999',
        lineStyle: {
          type: 'dotted'
        }
      }
    ]
  };
  get chart() {
    return this.$refs.chart as any
  }
  @Watch('dataList', { immediate: true, deep: true })
  onDataChange(val: any) {
    if (!this.dataList.length) return
    let names = []
    let data = []
    let normData = []
    this.dataList.map((item: any) => {
      names.push(item.name)
      data.push(item.values[0])
      // normData.push(item.values[1])
    })
    this.option.xAxis.data = names
    this.option.series[0].data = data
    this.option.series[1].data = normData
    this.$nextTick(() => {
      this.chart.update()
    })
  }
  created() {
    this.chartId =
      new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
  }
}
